import axios from "../../axios";

const BASE_URL = "/organization-questionnaires";

// CATEGORY 2
const api = {
  updateCapitalGoods({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`${BASE_URL}/${questionnaireId}/capital-goods`, data, headers).then(({ data }) => data);
  },

  getCapitalGoodsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/capital-goods/items`,
      config).then(({ data }) => data);
  },

  addCapitalGoodsItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/capital-goods/items`, data, headers)
      .then(({ data }) => data);
  },

  updateCapitalGoodsItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/capital-goods/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteCapitalGoodsItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/capital-goods/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importCapitalGoodsItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/capital-goods/items/import`, data, headers).then(({ data }) => data);
  },

  getCapitalGoodsTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/capital-goods/items/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope3_Category2_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },
};


export default api;
